export default {
  contactLinkFailed(state, payload) {
    state.contactLinkFailed = payload.contactLinkFailed;
  },
  contactLinkSuccess(state,payload){
      state.contactLinkSuccess=payload.contactLinkSuccess
  }
};
